/* eslint-disable import/prefer-default-export */
export const GET_PAYMENT_HISTORY = 'machinery/get_payment_history';
